import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'phrase-builder',
  templateUrl: './phrase-builder.component.html',
  styleUrls: ['./phrase-builder.component.scss'],
})
export class PhraseBuilderComponent {

  @Output() builtPhraseChange: EventEmitter<string> = new EventEmitter<string>();
  public remainingWords = Array();
  private inputPhraseWords = Array();
  private builtPhraseWords = Array();
  public wordGrid = Array();
  private deletedWords = Array();
  @Input() showOnly: boolean = false;

  constructor() {
  }

  get inputPhrase() {
    return this.inputPhraseWords.join(' ');
  }

  @Input()
  set inputPhrase(phrase: string) {
    if (!phrase) {
      return;
    }

    this.inputPhraseWords = phrase.split(' ');
    if (this.showOnly) {
      this.remainingWords = this.inputPhraseWords.slice();
    } else {
      this.remainingWords = this.shuffle(this.inputPhraseWords);
    }

    for (let i = 0; i < Math.ceil(this.inputPhraseWords.length / 3); i++) {
      const wordRow = Array();
      for (let j = i * 3; j < (i * 3) + 3; j++) {
        wordRow.push(this.remainingWords[j]);
      }
      this.wordGrid.push(wordRow);
    }
  }

  get builtPhrase() {
    return this.builtPhraseWords.join(' ');
  }

  builtPhraseDeleteWord() {
    if (this.builtPhraseWords.length > 0) {
      const lastDeletedWord: string = this.builtPhraseWords[this.builtPhraseWords.length - 1];
      this.builtPhraseWords.pop();
      this.remainingWords.push(lastDeletedWord);
      this.deletedWords.pop();

      if (this.builtPhraseChange) {
        this.builtPhraseChange.emit(this.builtPhrase);
      }
    }
  }

  getWordVisibility(coord: object) {
    return this.deletedWords.find((el) => JSON.stringify(el) === JSON.stringify(coord)) ? 'hidden-word' : '';
  }

  removeElement(array, elem, coord) {
    const index = array.indexOf(elem);
    if (index > -1) {
      this.deletedWords.push(coord);
      array.splice(index, 1);
    }
    return array;
  }

  handleWord(word: string, coord: object) {

    this.builtPhraseWords.push(word);
    
    if (!this.showOnly) {
      this.remainingWords = this.removeElement(this.remainingWords, word, coord);
    }

    if (this.builtPhraseChange) {
      this.builtPhraseChange.emit(this.builtPhrase);
    }
  }

  private shuffle(array: Array<string>) {
    let currentIndex: number = array.length,
      temporaryValue: string,
      randomIndex: number;

    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array;
  }

}
